import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import StoreLocatorLink from 'Component/StoreLocatorLink/StoreLocatorLink.component';

/** @namespace PeggysagePwa/Component/StoreLocatorLink/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    storeCode: state.ConfigReducer.code
});

/** @namespace PeggysagePwa/Component/StoreLocatorLink/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({});

/** @namespace PeggysagePwa/Component/StoreLocatorLink/Container */
export class StoreLocatorLinkContainer extends PureComponent {
    static propTypes = {
        storeCode: PropTypes.string.isRequired,
        hasLabel: PropTypes.bool
    };

    static defaultProps = {
        hasLabel: true
    };

    containerProps() {
        const { storeCode, hasLabel } = this.props;

        return {
            storeCode,
            hasLabel
        };
    }

    render() {
        return (
            <StoreLocatorLink
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreLocatorLinkContainer);
